import React from 'react';
import { Desktop, Mobile } from '../../../../app-responsive';
import SSMRadioButton from '../../../ssm-homepage/ssm-components/ssm-radio-button/ssm-radio-button';
import './email-table.css';

const EmailTable = (props) => {
  const {
    authorableContent,
    emailList,
    emailSelectionCheckedStatus,
    onEmailSelectionStatusChanged,
    onAllSelectionChanged,
  } = props;

  const {
    currentServicesHeading,
    emailHeading,
    actionHeading,
    migrateText,
    cancelText,
    migrateAllText,
    cancelAllText,
  } = authorableContent;


  const emailListContentDesktop = emailList.map(email => (
    <div className="row email-item-row" key={email}>
      <div className="col-6">
        <span className="sub-heading">{email}</span>
      </div>
      <div className="col-3">
        <SSMRadioButton
          radioButtonId={`Migrate|${email}`}
          radioButtonChecked={emailSelectionCheckedStatus &&
            emailSelectionCheckedStatus[email] &&
            emailSelectionCheckedStatus[email] === 'Migrate'
          }
          radioButtonLabel={migrateText}
          onRadioButtonCallBackActionWithToggle={onEmailSelectionStatusChanged}
        />
      </div>
      <div className="col-3">
        <SSMRadioButton
          radioButtonId={`Cancel|${email}`}
          radioButtonChecked={emailSelectionCheckedStatus &&
            emailSelectionCheckedStatus[email] &&
            emailSelectionCheckedStatus[email] === 'Cancel'
          }
          radioButtonLabel={cancelText}
          onRadioButtonCallBackActionWithToggle={onEmailSelectionStatusChanged}
        />
      </div>
    </div>
  ));

  // emailHeading
  const emailListContentMobile = emailList.map(email => (
    <div className="row email-item-row" key={email}>
      <div className="col-12">
        <span className="sub-heading">{emailHeading}</span>
      </div>
      <div className="col-12 main-row">
        <span className="sub-heading">{email}</span>
      </div>
      <div className="col-6">
        <SSMRadioButton
          radioButtonId={`Migrate|${email}`}
          radioButtonChecked={emailSelectionCheckedStatus &&
            emailSelectionCheckedStatus[email] &&
            emailSelectionCheckedStatus[email] === 'Migrate'
          }
          radioButtonLabel={migrateText}
          onRadioButtonCallBackActionWithToggle={onEmailSelectionStatusChanged}
        />
      </div>
      <div className="col-6">
        <SSMRadioButton
          radioButtonId={`Cancel|${email}`}
          radioButtonChecked={emailSelectionCheckedStatus &&
            emailSelectionCheckedStatus[email] &&
            emailSelectionCheckedStatus[email] === 'Cancel'
          }
          radioButtonLabel={cancelText}
          onRadioButtonCallBackActionWithToggle={onEmailSelectionStatusChanged}
        />
      </div>
    </div>
  ));

  return (
    <div className="email-table-section">
      <Desktop>
        <div className="row">
          <div className="col-6 main-row">
            <span className="heading">{currentServicesHeading}</span>
          </div>
          <div className="col-6 main-row">
            <span className="heading">{actionHeading}</span>
          </div>
          <div className="col-6">
            <span className="sub-heading">{emailHeading}</span>
          </div>
          <div className="col-3">
            <SSMRadioButton
              radioButtonId="migrateall"
              radioButtonChecked={emailSelectionCheckedStatus &&
                emailSelectionCheckedStatus.migrateall
              }
              radioButtonLabel={migrateAllText}
              onRadioButtonCallBackActionWithToggle={onAllSelectionChanged}
            />
          </div>
          <div className="col-3">
            <SSMRadioButton
              radioButtonId="cancelall"
              radioButtonChecked={emailSelectionCheckedStatus &&
                emailSelectionCheckedStatus.cancelall
              }
              radioButtonLabel={cancelAllText}
              onRadioButtonCallBackActionWithToggle={onAllSelectionChanged}
            />
          </div>
        </div>
        {emailListContentDesktop}
      </Desktop>
      <Mobile>
        <div className="row">
          <div className="col-12 main-row">
            <span className="heading">{currentServicesHeading}</span>
          </div>
          <div className="col-6">
            <SSMRadioButton
              radioButtonId="migrateall"
              radioButtonChecked={emailSelectionCheckedStatus &&
                emailSelectionCheckedStatus.migrateall
              }
              radioButtonLabel={migrateAllText}
              onRadioButtonCallBackActionWithToggle={onAllSelectionChanged}
            />
          </div>
          <div className="col-6">
            <SSMRadioButton
              radioButtonId="cancelall"
              radioButtonChecked={emailSelectionCheckedStatus &&
                emailSelectionCheckedStatus.cancelall
              }
              radioButtonLabel={cancelAllText}
              onRadioButtonCallBackActionWithToggle={onAllSelectionChanged}
            />
          </div>
        </div>
        {emailListContentMobile}
      </Mobile>
    </div>
  );
};

export default EmailTable;

